import moment from 'moment';
import {connect} from 'react-redux';
import {updatePreferences} from '../actionCreators/preferences';
import CustomiseCoverLetter from '../components/CustomiseCoverLetter';
import {findSection, updateSectionValue} from '../ducks/reportSections';
import {getIn} from '../lib/immutableObject';
import {titleCase} from '../lib/StringUtils';
import {joinNonEmpties} from 'api/reports/util/StringUtils';
import get from 'lodash/get';

export const defaultLetter = ({singleLineAddress}) => (
`${moment().format('Do MMMM YYYY')}

Dear Reader,
Thank you for the opportunity to appraise your property at ${singleLineAddress}

Careful consideration has been taken to provide you with an appraisal for your property in today's market conditions.

To establish a market value, I have carefully considered the premises, size, location, along with current market conditions and similar properties recently sold or currently on the market.

If you have any questions about the information outlined in this appraisal, please don't hesitate to contact me using the details below. I am happy to assist further and look forward to working with you to achieve your real estate goals.

Yours Sincerely,`);

const mapStateToProps = (state) => {

  const propertyDetail = state.propertyDetail;

  const localityName = titleCase(propertyDetail.localityName);
  const addressState = get(propertyDetail, 'state', '').toUpperCase();
  const town = titleCase(get(propertyDetail, 'town', ''));
  const postcode = get(propertyDetail, 'postcode');

  const locationAddress = joinNonEmpties([
    localityName,
    town,
    addressState,
    postcode,
  ], ' ') || '';

  const defaultToAddressContent = `The Proprietor\n${titleCase(propertyDetail.addressStreet)}\n${locationAddress}`;

  const section = findSection(state.reportSections, state.reportType.value, 'COVER_LETTER');

  const userDetails = state.userDetails;
  const suburbAddress = [userDetails.suburb, userDetails.state, userDetails.postalCode].join(' ');
  const mobile = userDetails.workMobileNumber && `m: ${userDetails.workMobileNumber}`;
  const email = userDetails.email;
  const sectionAddress = [
    `${userDetails.firstName} ${userDetails.lastName}`,
    userDetails.tradeName,
    userDetails.address1,
    userDetails.address2,
    suburbAddress,
    mobile,
    email,
  ].join('\n');

  const toAddress = section.sectionData && section.sectionData.toAddress ? section.sectionData.toAddress : defaultToAddressContent;
  const letterContent = (section.sectionData && section.sectionData.letterContent)
    || getIn(section, ['sectionData', 'savedLetterContent'])
    || defaultLetter(propertyDetail);

  const fromAddress = section.sectionData && section.sectionData.fromAddress && section.sectionData.fromAddress.trim() ? section.sectionData.fromAddress : sectionAddress;
  return {
    reportType: state.reportType.value,
    agencyLogo: state.userDetails.agencyLogoUri,
    colour: state.theme.colour,
    fromAddress,
    letterContent,
    toAddress,
    defaultLetterContent: defaultLetter(propertyDetail),
    defaultAddressFrom: sectionAddress,
    defaultAddressTo: defaultToAddressContent,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSectionChange: (reportType, keyPath, value) => {
      dispatch(updateSectionValue({value, reportType, key: 'COVER_LETTER', dataKeyPath: `sectionData.${keyPath}`}, keyPath !== 'fromAddress'));
      if (keyPath === 'fromAddress' || keyPath === 'savedLetterContent') {
        dispatch(updatePreferences({[`coverLetter.sectionData.${keyPath}`]: value}, reportType));
      }
    },
    onSaveLetterTemplate: (reportType, letterContent) => {
      return dispatch(updatePreferences({
        'coverLetter.sectionData.savedLetterContent': letterContent,
      }, reportType));
    },
  };
};

const mergeProps = (stateProps, dispatchProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    onSectionChange: (data) => {
      dispatchProps.onSectionChange(stateProps.reportType, data.key, data.value);
    },
    onSaveLetterTemplate: () => dispatchProps.onSaveLetterTemplate(stateProps.reportType, stateProps.letterContent),
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(CustomiseCoverLetter);